export default "__VITE_ASSET__7dl_AhiT__"